import { htmlEncode } from "helpers";
import { createLogger } from "logging";

const replacers = new Map<string, (s: string) => string>();
replacers.set("", (s: string) => s);

const escapeWordRegex = /[.*+?^${}()|[\]\\]/g;
const trimDashRegex = /^-*|[-*]*$/gi;

const logger = createLogger("HighlightFn");
logger.trace(`init`, replacers);

export function higlightFn(before: string, highlight: string) {
  logger.trace(`higlightFn(): content='${before}', highlight='${highlight}'`);
  if (!before) {
    return "";
  }

  let after = htmlEncode(before);
  if (!highlight) {
    return after;
  }

  const words = highlight.split(/[\s-]/gi).filter((x) => x);
  logger.trace(`tokenized '${highlight}' -> `, words);
  if (words.length === 0) {
    return after;
  }

  words.forEach((word, wi) => {
    let cleanWord = word.replace(trimDashRegex, "");
    cleanWord = cleanWord.replace(escapeWordRegex, "\\$&");
    if (cleanWord !== word) {
      logger.trace(`${wi}: cleaned '${word}' -> '${cleanWord}'`);
    }

    let fn = replacers.get(cleanWord);
    if (!fn) {
      fn = (s: string) => {
        let r = `${s}`;
        r = r.replace(new RegExp(cleanWord, "gi"), (m: string, mi: number, mo: string) => {
          logger.trace(`replace(): match:='${m}', index=${mi}, original='${mo}'`);
          const mEscaped = htmlEncode(m);
          return `<<<<${mEscaped}>>>>`;
        });
        if (r !== s) logger.trace(`replace(): '${s}' -> '${r}'`);
        return r;
      };
      replacers.set(word, fn);
    }
    if (fn && typeof fn === "function") {
      after = fn(after);
    }
  });

  if (after.includes("<<<<") || after.includes(">>>>")) {
    logger.trace("with markers", after);
  }

  after = after.replace(/(<<<<)+/gi, "<mark>");
  after = after.replace(/(>>>>)+/gi, "</mark>");
  after = after.replace(/ /gi, "&#32;");

  if (after !== before) {
    logger.trace(`'${before}' -> '${after}'`);
  }

  return after;
}
